export { AppConfigService } from './app.config.service';

export { AppConfigProperty } from './app.config';
